import {bindPopover, bindTrigger, usePopupState} from "material-ui-popup-state/hooks";
import {
    Button,
    capitalize,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Link,
} from "@mui/material";
import {useOnboardingHandling} from "../../hooks/onboarding/useOnboardingHandling";
import PrivacyPolicy from "./PrivacyPolicy";
import {useTranslation} from "react-i18next";

export default function ButtonShowOnboardingDataPrivacy({...props}) {
    const {translation} = useOnboardingHandling();
    const {i18n} = useTranslation();
    const currentLang = i18n.resolvedLanguage || 'en';

    const popupState = usePopupState({
        variant: 'popover',
        popupId: `onboarding-show-data-privacy`,
    });

    return (
        <>
            <Link
                {...bindTrigger(popupState)}
                sx={{
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    ml: 0.5,
                    '&:hover': {textDecoration: 'none'}
                }}
            >
                {translation('confirmation-data-privacy-link')}
            </Link>
            <Dialog id={`dialog-onboarding-show-data-privacy`}
                    {...bindPopover(popupState)}
                    fullWidth
                    maxWidth={"md"}
            >
                <DialogTitle id={`dialog-title-onboarding-show-data-privacy`}>
                    {capitalize(translation('data-privacy-hints'))}
                </DialogTitle>
                <DialogContent id={`dialog-content-onboarding-show-data-privacy`} sx={{ padding: 0 }}>
                    <PrivacyPolicy language={currentLang}/>
                </DialogContent>
                <DialogActions>
                    <Button id={`dialog-action-cancel-onboarding-show-data-privacy`}
                            variant={'contained'}
                            color={'inherit'}
                            onClick={() => popupState.close()}
                    >
                        {capitalize(translation('understand'))}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
